import {BookingOption} from '../enums/BookingOption';

export class CoffeeConfig {
  id: number;
  officeId: number;
  bookingOption: BookingOption;
  value: number;

  public constructor(init?: Partial<CoffeeConfig>) {
    Object.assign(this, init);
  }
}
